<template>
  <div class="card">
    <div class="card-body hm400">
      <h5 class="card-title text-center font-weight-bold">Announcements</h5>

      <div class="" v-if="loading">
        <!-- Show the loader when async operation is going on -->
        <div class="loader"></div>
      </div>
      <div  v-else>
      <perfect-scrollbar v-if='announcementGroup && announcementGroup.length' class="scroll-area">
        <div class="container hm300">
          <ul class="list-group list-group-flush">
            <li class="list-group-item announcement-item" v-for="(row) in announcementGroup" :key="row.id" @click="openAnnouncement(row)">
              <div class="d-flex align-items-center">
                <div class="col-md-1 pl-0 pr-0">
                  <img class="rounded-circle" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.createdByEmail)}?s=50`">
                </div>
                <div class="col-md-11 pr-0">
                  <span :class="row.acknowledgements && row.acknowledgements.length && row.acknowledgements.includes(user.uid) ? 'text-close' : 'text-open'" class="mb-0 make-cursor-pointer" v-html="row.title"></span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
        <p v-else class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p>
      <hr>
      <div class="d-flex justify-content-end"><a href="/admin/communications">View all Announcements</a></div>
    </div>
    </div>
    <announcement-modal :selected-announcement=selectedAnnouncement></announcement-modal>
  </div>

</template>
<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import md5 from "crypto-js/md5";
import AnnouncementModal from "@/components/Admin/AdminDashboard/modal/announcementModal.vue";
export default {
  name: "Announcement",
  components: {
    AnnouncementModal,
    PerfectScrollbar
  },
  data () {
    return {
      announcementGroup: [],
      selectedAnnouncement: {},
      loading: false,
    }
  },
  mounted() {
    this.getTeamAnnouncements()
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openAnnouncement(announcement){
      this.selectedAnnouncement = announcement;
      $("#viewModal").modal('show');
    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    async getTeamAnnouncements() {
      try {
        this.loading = true;
        this.announcementGroup = []
        const ref = await db.collection('team-announcements').orderBy('createdAt', 'desc').limit(20).get();
        if (ref.size) {
          ref.forEach(el => {
            if(el.id !== 'counter') {
              this.announcementGroup.push({id: el.id, ...el.data()})
            }
          })
        }
      } catch (e) {
        console.log('error from team announcements', e.toString())
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style scoped lang="scss">
img{
  border-radius: 50%;
}
.list-group-item{
  &.announcement-item{
    padding: 18px 0px;
  }
}
.scroll-area {
  position: relative;
  max-height: 300px;
  /*overflow: hidden;*/
}
.text-closed{
  font-weight: 400 !important;
}
.text-open{
  font-weight: 700 !important;
}
</style>
